module.exports = __webpack_public_path__ + "static/02_LA.VIZUAL_JANOWO_PARK_III-1b15ec096a5d6715fa614700f49e4cf4.jpg";